export default "__VITE_PUBLIC_ASSET__dcf61a3f__"